import React from 'react';
import { bool, string } from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as svgIcons from '@fortawesome/pro-light-svg-icons';

import useStyles from './styles';

const AdornmentIcon = ({ error = false, valid = false, type }) => {
  const styles = useStyles();

  if (error) {
    return (
      <FontAwesomeIcon icon={svgIcons[type]} size="lg" className={styles.error}/>
    );
  }
  if (valid) {
    return (
      <FontAwesomeIcon icon={svgIcons[type]} size="lg" className={styles.valid}/>
    );
  }

  return (
    <FontAwesomeIcon icon={svgIcons[type]} size="lg" className={styles.disabled}/>
  );
};

AdornmentIcon.propTypes = {
  error: bool,
  valid: bool,
  type: string,
};

export default AdornmentIcon;
